import dayjs from 'dayjs';
import Grade from './Grade.js';
import PayrollRank from './PayrollRank.js';

export default class SalaryIncreaseStep {
  constructor(data) {
    this.id = data?.id;
    this.gradeId = data?.gradeId;
    this.payrollRankId = data?.payrollRankId;
    this.step = data?.step;
    this.createdAt = data?.createdAt ? dayjs(data.createdAt) : null;
    this.updatedAt = data?.updatedAt ? dayjs(data.updatedAt) : null;

    this.grade = data?.grade ? new Grade(data?.grade) : null;
    this.payrollRank = data?.payrollRank ? new PayrollRank(data?.payrollRank) : null;
  }
}
